import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #BREADCRUMBS-ITEM
\*------------------------------------ */
/**
 * 1) Singular item within the breadcrumbs component that contains a link elsewhere on the site
 */
.cat-c-breadcrumbs__item {
  display: flex;
  align-items: center;
  font-family: var(--cat-theme-typography-body-font-family);
  font-weight: var(--cat-theme-typography-body-font-weight);
  font-size: var(--cat-theme-typography-body-font-size);
  line-height: var(--cat-theme-typography-body-line-height);
  font-weight: var(--cat-font-weight-regular);
  font-size: var(--cat-font-size-14);
  line-height: var(--cat-line-height-20);
  color: var(--cat-theme-color-content-strong);
  /**
  * Breadcrumbs item within the last cat-breadcrumbs-item wrapper
  * 1) Change the treatment to not represent a link
  */
}
:host(:last-child) .cat-c-breadcrumbs__item {
  color: var(--cat-theme-color-content-strong);
}

.cat-c-breadcrumbs__after {
  margin-inline-start: var(--cat-space-3x-small);
}

.cat-c-breadcrumbs__before {
  margin-inline-end: var(--cat-space-3x-small);
}

/**
* Breadcrumbs Active Item
* Active Button color should be in black color
*/
.cat-c-breadcrumbs__item--active {
  --cat-theme-color-content-link-default: var(--cat-color-neutral-100);
}

/**
* Breadcrumbs link 
*/
.cat-c-breadcrumbs__link {
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--cat-theme-color-content-link-default);
  /**
  * Breadcrumbs Active Item
  */
  /**
  * Breadcrumbs item simple
  */
}
:is(.cat-c-breadcrumbs__item--mobile) .cat-c-breadcrumbs__link:is(:hover, :focus) {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__link:hover {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__item .cat-c-breadcrumbs__link:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link:active {
  color: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--active .cat-c-breadcrumbs__link {
  color: var(--cat-color-neutral-100);
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link {
  display: flex;
  flex-direction: row;
  /**
  * Breadcrumbs item simple icon placement + fill
  */
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link cat-icon,
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link .cat-icon {
  place-self: center;
  --cat-icon-fill: var(--cat-theme-color-content-link-default);
}
.cat-c-breadcrumbs__link:hover cat-icon,
.cat-c-breadcrumbs__link:hover .cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-link-hover);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link:after {
  content: var(--cat-c-breadcrumb__item-loader-content, "");
  height: calc(var(--size-base-unit) * 0.125);
  width: 100%;
  background: var(--cat-theme-color-content-link-default);
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.25);
  inset-inline-start: 0;
}
.cat-c-breadcrumbs__link:hover:after {
  background: var(--cat-theme-color-content-link-hover);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link:active:after {
  background: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--active .cat-c-breadcrumbs__link:after {
  background: none;
}

.cat-c-breadcrumbs__link ::slotted(a) {
  position: relative;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: var(--cat-theme-color-content-link-default);
  /**
  * Breadcrumbs Active Item
  */
  /**
  * Breadcrumbs item simple
  */
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link ::slotted(a):hover, .cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link ::slotted(a):focus, .cat-c-breadcrumbs__link ::slotted(a):hover, .cat-c-breadcrumbs__link ::slotted(a):focus {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__link ::slotted(a):hover {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__item .cat-c-breadcrumbs__link ::slotted(a):focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link ::slotted(a):active {
  color: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--active .cat-c-breadcrumbs__link ::slotted(a) {
  color: var(--cat-color-neutral-100);
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link ::slotted(a) {
  display: flex;
  flex-direction: row;
  /**
  * Breadcrumbs item simple icon placement + fill
  */
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link ::slotted(a) cat-icon,
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link ::slotted(a) .cat-icon {
  place-self: center;
  --cat-icon-fill: var(--cat-theme-color-content-link-default);
}
.cat-c-breadcrumbs__link ::slotted(a):hover cat-icon,
.cat-c-breadcrumbs__link ::slotted(a):hover .cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-link-hover);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link ::slotted(a):after {
  content: var(--cat-c-breadcrumb__item-loader-content, "");
  height: calc(var(--size-base-unit) * 0.125);
  width: 100%;
  background: var(--cat-theme-color-content-link-default);
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.25);
  inset-inline-start: 0;
}
.cat-c-breadcrumbs__link ::slotted(a):hover:after {
  background: var(--cat-theme-color-content-link-hover);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__link ::slotted(a):active:after {
  background: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--active .cat-c-breadcrumbs__link ::slotted(a):after {
  background: none;
}

.cat-c-breadcrumbs__item .cat-c-breadcrumbs__link:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
* Breadcrumbs item simple
*/
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link:hover {
  /**
  * Breadcrumbs item simple icon placement + fill
  */
}
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link:hover cat-icon,
.cat-c-breadcrumbs__item--mobile .cat-c-breadcrumbs__link:hover .cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-link-hover);
}

.cat-c-breadcrumbs__separator {
  margin: 0 var(--cat-space-x-small);
}
.cat-c-breadcrumbs__separator .default-seperator {
  display: inline-block;
  transform: rotate(var(--rtlRotate135, 0));
}

/**
* Breadcrumbs icon
*/
cat-icon,
.cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-strong);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  margin-inline-end: var(--cat-space-x-small);
}

/**
* Mobile
*/
.cat-c-breadcrumbs__item--mobile--action {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  color: var(--cat-theme-color-content-link-default);
  /**
  * Breadcrumbs item simple icon placement + fill
  */
}
.cat-c-breadcrumbs__item--mobile--action .cat-c-breadcrumbs__item--text {
  position: relative;
}
.cat-c-breadcrumbs__item--mobile--action .cat-c-breadcrumbs__item--text:after {
  content: var(--cat-c-breadcrumb__item-loader-content, "");
  height: calc(var(--size-base-unit) * 0.125);
  width: 100%;
  background: var(--cat-theme-color-content-link-default);
  position: absolute;
  inset-block-end: 2px;
  inset-inline-start: 0;
}
.cat-c-breadcrumbs__item--mobile--action .cat-c-breadcrumbs__item--text:hover:after {
  background: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__item--mobile--action .cat-c-breadcrumbs__item--text:active:after {
  background: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--mobile--action svg {
  place-self: center;
}
.cat-c-breadcrumbs__item--mobile--action:hover .cat-c-breadcrumbs__item--text {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__item--mobile--action:hover cat-icon,
.cat-c-breadcrumbs__item--mobile--action:hover .cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-link-hover);
}
.cat-c-breadcrumbs__item--mobile--action:active .cat-c-breadcrumbs__item--text {
  color: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--mobile--action:active cat-icon,
.cat-c-breadcrumbs__item--mobile--action:active .cat-icon {
  --cat-icon-fill: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--mobile--action cat-icon,
.cat-c-breadcrumbs__item--mobile--action .cat-icon {
  place-self: center;
  --cat-icon-fill: var(--cat-theme-color-content-link-default);
}
.cat-c-breadcrumbs__item--mobile--action:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
* BreadCrumb Button Variant Styles
*/
.cat-c-breadcrumbs__item--label--button {
  color: var(--cat-theme-color-content-link-default);
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
  background-color: transparent;
  border: none;
  cursor: pointer;
  padding: 0;
  margin: 0;
  font-weight: var(--cat-font-weight-regular);
  font-size: var(--cat-font-size-14);
  line-height: var(--cat-line-height-20);
}
.cat-c-breadcrumbs__item--label--button:hover {
  color: var(--cat-theme-color-content-link-hover);
  --cat-icon-fill: var(--cat-color-brand-blue-60);
}
:is(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__item--label--button {
  color: var(--cat-theme-color-content-link-default);
}
.cat-c-breadcrumbs__item .cat-c-breadcrumbs__item--label--button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__item--label--button:active {
  color: var(--cat-theme-color-content-link-active);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__item--label--button:after {
  content: var(--cat-c-breadcrumb__item-loader-content, "");
  height: calc(var(--size-base-unit) * 0.125);
  width: 100%;
  background: var(--cat-theme-color-content-link-default);
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.25);
  inset-inline-start: 0;
}
.cat-c-breadcrumbs__item--label--button:hover:after {
  background: var(--cat-theme-color-content-link-hover);
}
:not(.cat-c-breadcrumbs__item--active) .cat-c-breadcrumbs__item--label--button:active:after {
  background: var(--cat-theme-color-content-link-active);
}
.cat-c-breadcrumbs__item--active .cat-c-breadcrumbs__item--label--button:after {
  background: none;
}

.cat-c-breadcrumbs__showmore {
  cursor: pointer;
  display: flex;
  align-items: center;
}

.cat-c-breadcrumbs__item:not(.cat-c-breadcrumbs--has-before) [part=before-wrapper], .cat-c-breadcrumbs__item:not(.cat-c-breadcrumbs--has-after) [part=after-wrapper], .cat-c-breadcrumbs__item:not(.cat-c-breadcrumbs--has-showmore) [part=show-more-wrapper], .cat-c-breadcrumbs__item:not(.cat-c-breadcrumbs--has-no-showmore) .cat-c-breadcrumbs__item--label--button, .cat-c-breadcrumbs__item:not(.cat-c-breadcrumbs--not-is-last) :is(.breadcrumbs-separator-mobile, .breadcrumbs-separator-lg) {
  display: none;
}
`;
       